import { translate as t } from '@thoughtspot/i18n';
import { parseData } from "../../../services/system/system-service";
const validationErrorMapping = {
    100: t('error.validation.default'),
    101: t('error.validation.ipAddress'),
    102: t('error.validation.port'),
    103: t('error.validation.fromName'),
    104: t('error.validation.email'),
    105: t('error.validation.ldapAddress'),
    106: t('error.validation.domainName'),
    107: t('error.validation.serverAddress'),
    108: t('error.validation.protocol'),
};
export const fetchError = (data) => {
    const error = parseData(data.Error);
    if (error.includes('invalid') && error.includes('schedule')) {
        return [t('error.retentionPolicy.invalidSchedule')];
    }
    if (!error.error)
        return [error];
    return Object.values(error.error).map((code) => {
        return validationErrorMapping[code];
    });
};
//# sourceMappingURL=active-directectory-util.js.map